import { Admission } from '@domain/admission';
import { CompanyRoles, ROLE_PROMOTER, ROLE_TEAM_LEADER } from '@domain/company';

export const filterOfferBasedOnRole = ({
  role,
  isImportLimited,
  selectedOffer,
}: {
  role?: CompanyRoles;
  isImportLimited: boolean;
  selectedOffer: Admission;
}) => {
  if (role !== ROLE_TEAM_LEADER && role !== ROLE_PROMOTER) return true;
  return !isImportLimited && !selectedOffer.settings.isHidden;
};
